import { render, staticRenderFns } from "./Ecoles.vue?vue&type=template&id=8c97d3e0&"
import script from "./Ecoles.vue?vue&type=script&lang=js&"
export * from "./Ecoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports